(function () {
    function register() {
        Alpine.data('syvColour', (opts = {}) => ({
            swatches: opts.variants || [],
            selected: (opts.initialHex || '#808080'),
            shade: Number(opts.initialShade ?? 50),

            selectSwatch(hex) {
                this.selected = hex;
                this.$nextTick(() => {
                    const form = this.$el.closest('form');
                    if (form) form.dispatchEvent(new CustomEvent('colour-update', { bubbles: false }));
                });
            },

            computeHex(hex, factor) {
                const s = String(hex || '').trim();
                if (!/^#[0-9a-fA-F]{6}$/.test(s)) return s;
                const r = parseInt(s.slice(1, 3), 16);
                const g = parseInt(s.slice(3, 5), 16);
                const b = parseInt(s.slice(5, 7), 16);
                const clamp = v => Math.min(255, Math.max(0, Math.round(v * factor)));
                const h = v => v.toString(16).padStart(2, '0');
                return '#' + h(clamp(r)) + h(clamp(g)) + h(clamp(b));
            },

            get factor() { return 0.5 + (this.shade / 100); },
            get finalHex() { return this.computeHex(this.selected, this.factor); },

            // After the colour POST completes, regen the QR preview (was hx-on::after-request).
            afterColourUpdate() {
                const f = document.getElementById('qr-config-form');
                if (f && window.htmx) window.htmx.trigger(f, 'regen');
            }
        }));

        Alpine.data('syvResend', (secs = 0) => ({
            remaining: secs,
            _timer: null,

            init() {
                if (this.remaining > 0) {
                    this._timer = setInterval(() => {
                        if (--this.remaining <= 0) {
                            clearInterval(this._timer);
                            this._timer = null;
                        }
                    }, 1000);
                }
            },

            destroy() {
                if (this._timer) {
                    clearInterval(this._timer);
                    this._timer = null;
                }
            },

            get label() {
                return this.remaining > 0
                    ? 'resend in ' + this.remaining + 's'
                    : 'resend the code';
            }
        }));
    }
    if (window.Alpine) register();
    else document.addEventListener('alpine:init', register);
})();
